export const countryLanderPath = (countryCode: string) =>
  `/${countryCode.toLowerCase()}`

// Mirrors MarketPathConstraint (and routes/marketPaths.ts): a market whose
// slug is its country code collapses to the single-segment lander.
export const marketLanderPath = (
  market: { slug: string },
  countryCode: string,
) => {
  const country = countryCode.toLowerCase()
  const slug = market.slug.toLowerCase()

  return slug === country ? `/${slug}` : `/${country}/${slug}`
}

export const defaultStateCodeForMarket = (marketCode: GQL_MarketCode) => {
  switch (marketCode) {
    case 'NSW':
      return 'NSW'
    case 'VIC':
      return 'VIC'
    case 'NZ':
      return 'North Island'
    case 'WA':
      return 'WA'
    case 'OR':
      return 'OR'
    default:
      return 'all'
  }
}
